import React from 'react';
import styles from './Reports.module.css';
import { PageHeader } from '../components/layout/PageHeader';
import ExcelReports from '../components/reports/ExcelReports';

const Reports = () => {
  return (
    <div>
      <PageHeader pageName="Reports" />
      <ExcelReports />
    </div>
  );
};

export default Reports;
